import api from '@/services/api';

export default {
  list(params) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });
    const url = `/gad7/?${q.join('&')}`;

    return new Promise((resolve, reject) => {
      api.get(url).then((response) => {
        if (response.ok) {
          const data = response.body;
          resolve({ data, message: '', success: true });
        } else {
          reject(new Error(`List Error: ${response}, url: ${url}`), {
            data: null,
            success: false,
          });
        }
      });
    });
  },

  create(payload) {
    const url = '/gad7/';

    return new Promise((resolve, reject) => {
      api.post(url, payload).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(new Error(`Error: ${response.data.message}`), {
              data: null,
              success: false,
            });
          }
        },
        (response) => {
          reject(new Error(`Request Error: ${response}, url: ${url}`), {
            data: null,
            success: false,
          });
        },
      );
    });
  },

  rememberSection(payload) {
    const url = '/gad7/remember';

    return new Promise((resolve, reject) => {
      api.post(url, payload).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(new Error(`Error: ${response.data.message}`), {
              data: null,
              success: false,
            });
          }
        },
        (response) => {
          reject(new Error(`Request Error: ${response}, url: ${url}`), {
            data: null,
            success: false,
          });
        },
      );
    });
  },
};
